export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-secondary-100/40">
      <div className="max-w-[960px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
          关于亲亲漫画
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
          亲亲漫画是一个专注免费漫画在线阅读的平台，按地域精选韩漫、日漫、国漫热门推荐。
          我们致力于为漫画爱好者打造一个海量资源、流畅体验的漫画大全网站。
          平台收录超过五万部漫画作品，涵盖恋爱、热血、奇幻、悬疑、搞笑、古风等全品类题材，
          每日不间断更新连载内容。下拉式阅读设计让你无需等待翻页，沉浸式追漫体验一气呵成。
          无论你是韩漫迷、日漫粉还是国漫爱好者，亲亲漫画都是你看好看的漫画的最佳选择。
        </p>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
          <div className="p-4 rounded-xl bg-background-50 border border-background-200/70">
            <p className="text-2xl font-bold text-primary-600">50000+</p>
            <p className="text-xs text-foreground-500 mt-1">漫画资源</p>
          </div>
          <div className="p-4 rounded-xl bg-background-50 border border-background-200/70">
            <p className="text-2xl font-bold text-accent-600">800万+</p>
            <p className="text-xs text-foreground-500 mt-1">活跃读者</p>
          </div>
          <div className="p-4 rounded-xl bg-background-50 border border-background-200/70">
            <p className="text-2xl font-bold text-primary-600">每日更新</p>
            <p className="text-xs text-foreground-500 mt-1">持续连载</p>
          </div>
          <div className="p-4 rounded-xl bg-background-50 border border-background-200/70">
            <p className="text-2xl font-bold text-accent-600">3大地区</p>
            <p className="text-xs text-foreground-500 mt-1">韩漫日漫国漫</p>
          </div>
        </div>
      </div>
    </section>
  );
}